import script from "./tranding-product-one.vue?vue&type=script&setup=true&lang=js"
export * from "./tranding-product-one.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__